import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../utils/translations';

// Création du contexte
const LanguageContext = createContext();

// Hook personnalisé pour utiliser le contexte
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage doit être utilisé dans un LanguageProvider');
  }
  return context;
};

// Provider du contexte
export const LanguageProvider = ({ children }) => {
  // Récupère la langue du localStorage ou utilise 'fr' par défaut
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'fr';
  });

  // Sauvegarde la langue dans le localStorage quand elle change
  useEffect(() => {
    localStorage.setItem('language', language);
    // Optionnel : Change l'attribut lang du document HTML
    document.documentElement.lang = language;
  }, [language]);

  // Fonction pour changer de langue
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };

  // Fonction pour obtenir une traduction
  const t = (key) => {
    return translations[language]?.[key] || translations.fr[key] || key;
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};